export default __webpack_public_path__ + "static/media/banner-170x340-bg-pink-template.703d3d50.svg";